import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ReactToPrint from "react-to-print";
import NhapHangApi from "service/QuanLyMuaBan/NhapHangApi";

const InMuaHangModal = ({ onHide, orderId }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(false);
  const printRef = useRef();
  const fetchData = () => {
    if (!orderId) return;
    setLoading(true);
    NhapHangApi.getDataInChiTiet(orderId)
      .then((res) => {
        const data = res.data;
        console.log("data in: ", data);
        setHtmlContent(data || "<p>Không có nội dung phiếu in.</p>");
      })
      .catch((err) => {
        console.error(err);
        setHtmlContent("<p>Lỗi tải dữ liệu phiếu in.</p>");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Modal
      show={true}
      onHide={onHide}
      size="lg"
      centered
      className="modal fade text-left popup-detail"
      backdrop={false}
      keyboard={false}
      style={{ paddingRight: 15, display: "block" }}
    >
      <Modal.Header style={{ borderBottom: "none" }}>
        <h4 className="modal-title color7-bold">
          <span className="btn-icon-right color7-bold">
            <img
              src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
              alt="logo"
              style={{ height: 30 }}
            />
          </span>
          In nhập hàng</h4>
        <button
          type="button"
          className="btn btn-link text-danger"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
        </button>
      </Modal.Header>

      <Modal.Body id="in_muahang_content">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <p
            ref={printRef}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        )}

        <style>{`
        #in_muahang_content p, #in_muahang_content table {
          font-size: 1.1rem; 
        }
          .tableIn {
            width: 100%;
            border: 1px solid #CACFE7;
            border-collapse: collapse;
          }
          .tableIn th, .tableIn td {
            border: 1px solid #CACFE7;
            padding: 5px;
          }
        `}</style>
      </Modal.Body>
      <style>{`
          .popup-detail .back-ground-footer{
            background-color: #FFFFFF !important;
            border-bottom-left-radius: 0.5rem; 
            border-bottom-right-radius: 0.5rem;
          }
        `}</style>
      <Modal.Footer className="back-ground-footer">
        <ReactToPrint
          trigger={() => (
            <button disabled={loading} className="btn btn-checknew mr-1">
              <i className="mdi mdi-printer"></i> In đơn hàng
            </button>
          )}
          content={() => printRef.current}
        />
        <button onClick={onHide} className="btn btn-v2-close" style={{ minHeight: 40 }}>
          <img src="/app-assets/images/icon-close-v21.png" alt="close" /> Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InMuaHangModal;